import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store' // PENTING: tambahkan ini


const routes = [
  { path: '/', redirect: '/Login' },
  { path: '/Login', name: 'Login', component: () => import('@/components/Base/Auth/Login.vue') },
  { 
    path: '/Main', 
    name: 'Main',
    component: () => import('@/components/Layout/MainPage.vue'),
    children: [
      { path: '', redirect: { name: 'Home' } },
      { path: 'Home', name: 'Home', component: () => import('@/components/Home.vue') },

      { path: 'User', name: 'User', component: () => import('@/components/Base/User/Index.vue') },
      { path: 'UserEditor', name: 'UserEditor', component: () => import('@/components/Base/User/Editor.vue') },

      { path: 'Position', name: 'Position', component: () => import('@/components/Master/Position/Index.vue') },
      { path: 'PositionEditor', name: 'PositionEditor', component: () => import('@/components/Master/Position/Editor.vue') },

      { path: 'UserMapping', name: 'UserMapping', component: () => import('@/components/Master/UserMapping/Index.vue') },
      { path: 'UserMapping_Mapping', name: 'UserMapping_Mapping', component: () => import('@/components/Master/UserMapping/Mapping.vue') },

      { path: 'Branch', name: 'Branch', component: () => import('@/components/Master/Branch/Index.vue') },

      { path: 'BranchEditor', name: 'BranchEditor', component: () => import('@/components/Master/Branch/Editor.vue') },

      { path: 'Area', name: 'Area', component: () => import('@/components/Master/Area/Index.vue') },

      { path: 'GroupCity', name: 'GroupCity', component: () => import('@/components/Master/GroupCity/Index.vue') },

      { path: 'City', name: 'City', component: () => import('@/components/Master/City/Index.vue') },

      { path: 'Distributor', name: 'Distributor', component: () => import('@/components/Master/Distributor/Index.vue') },

      { path: 'District', name: 'District', component: () => import('@/components/Master/District/Index.vue') },
      { path: 'DistrictEditor', name: 'DistrictEditor', component: () => import('@/components/Master/District/Editor.vue') },

      { path: 'SKU', name: 'SKU', component: () => import('@/components/Master/SKU/Index.vue') },

      { path: 'APKVersion', name: 'APKVersion', component: () => import('@/components/Master/APKVersion/Index.vue') },

      { path: 'OutletMapping', name: 'OutletMapping', component: () => import('@/components/Transaction/OutletMapping/Index.vue') },
      { path: 'OutletMappingEditor', name: 'OutletMappingEditor', component: () => import('@/components/Transaction/OutletMapping/Editor.vue') },

      { path: 'HistoryOutlet', name: 'HistoryOutlet', component: () => import('@/components/Transaction/HistoryOutlet/Index.vue') },
      { path: 'HistoryOutletEditor', name: 'HistoryOutletEditor', component: () => import('@/components/Transaction/HistoryOutlet/Editor.vue') }
    ]
 }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.getToken

  if (to.name !== 'Login' && !isAuthenticated) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router